import store from "../store"

const defaultState = {
    byIds: {},
    allIds: [],
    loading: false,
    error: undefined,
    lastSuccessGetResult: []
} 

const teamMembersReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_TEAM_MEMBERS_REQUEST": 
            return { ...state, loading: true }
        case "GET_TEAM_MEMBERS_SUCCESS":
            let { team_members } = action.payload.data
            for (let team_member of team_members) {
                state.byIds[team_member.id] = team_member
                if (state.allIds.indexOf(team_member.id) === -1) state.allIds.push(team_member.id);
            }
            return { 
                error: undefined, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds },
                lastSuccessGetResult: [ ...action.payload.data.team_members ], 
            }
        case "GET_TEAM_MEMBERS_FAILED":
            return { ...state, error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        default:
            return state;
    }
}

export default teamMembersReducer;